import React from 'react'
import { SubscriptionDetail } from 'store/selection/selectionTypes'
import { PageControlsToolbarContainer } from './toolbarStyles'
import { IconButton } from 'view/components/buttons'
import * as gridIcons from '../styles/gridIconSet'
import { Locale, Translation } from 'locale'

interface PageControlsToolbarProps {
  subscriptionDetail?: SubscriptionDetail
  onPageChanged: (pageNumber: number) => unknown
}

export const PageControlsToolbar: React.FC<PageControlsToolbarProps> = ({ subscriptionDetail, onPageChanged }) => {
  const page = subscriptionDetail?.page ?? 0
  const totalPages = subscriptionDetail?.totalPages ?? 0
  const resultCount = subscriptionDetail?.resultCount ?? 0

  const invalidDetails = page + 1 > totalPages || (page > 0 && resultCount === 0)

  return (
    <PageControlsToolbarContainer>
      <IconButton dataTestId={'PageControlsToolbar-FirstPageIconNavigator'} onClick={() => onPageChanged(0)} disabled={page === 0}>
        {gridIcons.firstPageIcon}
      </IconButton>
      <IconButton
        dataTestId={'PageControlsToolbar-PreviousPageIconNavigator'}
        onClick={() => onPageChanged(page - 1)}
        disabled={page === 0}>
        {gridIcons.previousPageIcon}
      </IconButton>
      <div data-test-id="PageControlsToolbar-PageNumbersContainer">
        {Locale.translate(Translation.SC_PAGE_CONTROL_PAGE)}
        <span>{invalidDetails ? '1' : page + 1}</span>
        {Locale.translate(Translation.SC_PAGE_CONTROL_OF)}
        <span>{invalidDetails ? '1' : totalPages}</span>
      </div>
      <IconButton
        dataTestId={'PageControlsToolbar-NextPageIconNavigator'}
        onClick={() => onPageChanged(page + 1)}
        disabled={page + 1 >= totalPages}>
        {gridIcons.nextPageIcon}
      </IconButton>
      <IconButton
        dataTestId={'PageControlsToolbar-LastPageIconNavigator'}
        onClick={() => onPageChanged(totalPages - 1)}
        disabled={page + 1 >= totalPages}>
        {gridIcons.lastPageIcon}
      </IconButton>
    </PageControlsToolbarContainer>
  )
}
